const webmgrRouter = {
  route: null,
  name: null,
  title: '网站管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  filePath: 'views/a_webmgr/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '网站信息',
      type: 'view',
      name: 'globalinfo',
      route: '/a_webmgr/globalinfo',
      filePath: 'plugins/a_webmgr/views/GlobalSetting.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '横幅管理',
      type: 'view',
      name: 'banner',
      route: '/a_webmgr/banner',
      filePath: 'plugins/a_webmgr/views/BannerSetting.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
    {
      title: '客户管理',
      type: 'view',
      name: 'custom',
      route: '/a_webmgr/custom',
      filePath: 'plugins/a_webmgr/views/CustomSetting.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
    },
  ],
}

export default webmgrRouter

